<div class="home-page">
  <!-- Hero Section -->
  <section class="hero">
    <div class="hero-bg"></div>
    <div class="hero-content">
      <div class="hero-icon-wrapper">
        <mat-icon class="hero-icon">widgets</mat-icon>
      </div>
      <h1 class="hero-title">Willkommen bei Containuel</h1>
      <p class="hero-subtitle">Ihre zentrale Plattform für Lagerverwaltung, Wartungsplanung und mehr.</p>
      <button mat-raised-button class="hero-btn" (click)="login()" *ngIf="!isAuthenticated">
        Jetzt anmelden
        <mat-icon>arrow_forward</mat-icon>
      </button>
      <div class="hero-chips">
        <div class="chip" (click)="goToLager()">
          <mat-icon>inventory_2</mat-icon>
          <span>Lager</span>
        </div>
        <div class="chip" (click)="goToWartung()">
          <mat-icon>build_circle</mat-icon>
          <span>Wartung</span>
        </div>
        <div class="chip" (click)="goToBerichte()">
          <mat-icon>bar_chart</mat-icon>
          <span>Berichte</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Stock Alert Section (only when authenticated) -->
  <section class="stock-section" *ngIf="isAuthenticated">
    <div class="stock-inner">

      <!-- Loading -->
      <div *ngIf="isLoadingStock" class="stock-loading">
        <mat-progress-spinner mode="indeterminate" diameter="36" color="primary"></mat-progress-spinner>
        <span>Lagerbestand wird geladen...</span>
      </div>

      <!-- Empty Stock Table -->
      <div class="stock-card danger" *ngIf="!isLoadingStock && emptyElements.length > 0">
        <div class="stock-card-header">
          <div class="stock-header-left">
            <mat-icon class="stock-header-icon danger-icon">error_outline</mat-icon>
            <div>
              <h2 class="stock-card-title">Leere Artikel</h2>
              <p class="stock-card-subtitle">{{ emptyElements.length }} Artikel mit Bestand 0</p>
            </div>
          </div>
          <button mat-stroked-button color="primary" class="stock-action-btn" (click)="goToLager()">
            <mat-icon>open_in_new</mat-icon>
            Zum Lager
          </button>
        </div>
        <div class="stock-table-wrap">
          <table class="stock-table">
            <thead>
              <tr>
                <th>Name</th>
                <th class="hide-mobile">Beschreibung</th>
                <th class="hide-mobile">Hersteller</th>
                <th>Kategorie</th>
                <th class="hide-sm">Bestellnr.</th>
                <th class="hide-sm">Lagerort</th>
                <th>Menge</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let el of emptyElements">
                <td class="td-name" [matTooltip]="el.name"><span class="td-truncate">{{ el.name }}</span></td>
                <td class="hide-mobile td-desc" [matTooltip]="el.description"><span class="td-truncate">{{ el.description }}</span></td>
                <td class="hide-mobile" [matTooltip]="el.hersteller"><span class="td-truncate">{{ el.hersteller }}</span></td>
                <td><span class="cat-badge" [matTooltip]="el.kategorie">{{ el.kategorie }}</span></td>
                <td class="hide-sm td-mono" [matTooltip]="el.bestellnumer"><span class="td-truncate">{{ el.bestellnumer }}</span></td>
                <td class="hide-sm" [matTooltip]="el.lager_lagerort || ''"><span class="td-truncate">{{ el.lager_lagerort }}</span></td>
                <td class="td-qty">
                  <span class="qty-zero">{{ el.quantity }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Low Stock Table -->
      <div class="stock-card warning" *ngIf="!isLoadingStock && lowStockElements.length > 0">
        <div class="stock-card-header">
          <div class="stock-header-left">
            <mat-icon class="stock-header-icon warning-icon">warning_amber</mat-icon>
            <div>
              <h2 class="stock-card-title">Niedriger Bestand</h2>
              <p class="stock-card-subtitle">{{ lowStockElements.length }} Artikel mit Bestand ≤ 5</p>
            </div>
          </div>
        </div>
        <div class="stock-table-wrap">
          <table class="stock-table">
            <thead>
              <tr>
                <th>Name</th>
                <th class="hide-mobile">Beschreibung</th>
                <th class="hide-mobile">Hersteller</th>
                <th>Kategorie</th>
                <th class="hide-sm">Bestellnr.</th>
                <th class="hide-sm">Lagerort</th>
                <th>Menge</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let el of lowStockElements">
                <td class="td-name" [matTooltip]="el.name"><span class="td-truncate">{{ el.name }}</span></td>
                <td class="hide-mobile td-desc" [matTooltip]="el.description"><span class="td-truncate">{{ el.description }}</span></td>
                <td class="hide-mobile" [matTooltip]="el.hersteller"><span class="td-truncate">{{ el.hersteller }}</span></td>
                <td><span class="cat-badge" [matTooltip]="el.kategorie">{{ el.kategorie }}</span></td>
                <td class="hide-sm td-mono" [matTooltip]="el.bestellnumer"><span class="td-truncate">{{ el.bestellnumer }}</span></td>
                <td class="hide-sm" [matTooltip]="el.lager_lagerort || ''"><span class="td-truncate">{{ el.lager_lagerort }}</span></td>
                <td class="td-qty">
                  <span class="qty-low">{{ el.quantity }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- All good -->
      <div class="stock-card success" *ngIf="!isLoadingStock && emptyElements.length === 0 && lowStockElements.length === 0">
        <div class="stock-card-header">
          <mat-icon class="stock-header-icon success-icon">check_circle</mat-icon>
          <div>
            <h2 class="stock-card-title">Lagerbestand in Ordnung</h2>
            <p class="stock-card-subtitle">Alle Artikel haben ausreichend Bestand.</p>
          </div>
        </div>
      </div>

    </div>
  </section>
</div>
